//#region src/updatePending.ts
var e = null;
function t(t) {
	e = t;
}
function n() {
	return e;
}
function r() {
	return e !== null;
}
//#endregion
export { n as getPendingUpdateSha, r as isUpdatePending, t as setUpdatePending };
